import client from '@/apis/aniftyBackend/client';

import { TransferV1Data } from './interface';

export type PostTokenTransfer = {
  tokenId: number;
  amount: number;
}[];

const postTokenTransfer = async (
  data: PostTokenTransfer
): Promise<TransferV1Data> => {
  const response = await client.post<TransferV1Data>(
    `/api/token_transfer`,
    data
  );

  return response.data;
};

export default postTokenTransfer;
